import React from 'react'
import BrainIcon from '../../icons/BrainIcon'
import { TestElem } from './TestElem'

export const ConProgress = ({list,classes,onClick}) => {
  return (
    <div>{
         Array.isArray(list) ?  list?.map( ( el,index )=>

            el?.conversationId ?
         (
          <TestElem key={el.id}  el={el}  
            onClick={onClick} 
            classes={classes}> 
               <BrainIcon className={classes.icon_test} /> 
          </TestElem>
         ) 
         :''
         
         )
         :''
   }
   </div>
  )
}
